/**
 * Mots-clés multilingues pour les types d'œuvre (FR, EN, DE, IT, etc.).
 * Utilisé pour le parsing des titres YouTube et le matching œuvres (worksReference).
 */

// Symphonie: EN, FR, DE, IT
const SYMPHONY_TERMS = [
  'Symphony', 'Symphonie', 'Sinfonia', 'Sinfonie',
]
// Sonate
const SONATA_TERMS = [
  'Sonata', 'Sonate',
]
// Concerto
const CONCERTO_TERMS = [
  'Concerto', 'Concert', 'Konzert',
]
// Autres types déjà utilisés
const OTHER_WORK_TERMS = [
  'Suite', 'Partita', 'Variations', 'Variationen',
  'Quartet', 'Quatuor', 'Quartett',
  'Quintet', 'Quintett', 'Quintette',
  'Trio', 'WoO',
  'Piano', 'Violin', 'Violon', 'Cello', 'Orchestra', 'Orchestre',
]
// Numéro / catalogue
const NUMBER_TERMS = [
  'No\\.?', 'N\\.?', 'n°', 'number', 'nr', '#', 'op\\.?', 'Op\\.?', 'BWV', 'K\\.', 'WoO',
]

/** Regex \b pour détecter le début d'un type d'œuvre (parsing tagGenerator) */
const WORK_TYPE_REGEX_SOURCE = [
  ...SYMPHONY_TERMS,
  ...SONATA_TERMS,
  ...CONCERTO_TERMS,
  ...OTHER_WORK_TERMS,
  ...NUMBER_TERMS,
  '#\\s*\\d',
  'op\\.?\\s*\\d',
  'K\\.\\s*\\d',
].join('|')

/** Regex pour "ce segment ne doit pas ressembler à un compositeur" (pas de type d'œuvre) */
export const WORK_TYPE_REGEX = new RegExp(`\\b(${WORK_TYPE_REGEX_SOURCE})\\b`, 'i')

/** Termes symphonie en minuscules pour matching (worksReference) */
export const SYMPHONY_NORMALIZED = '(?:symphony|symphonie|sinfonia|sinfonie)'

/** Regex pour numéro de symphonie : mot puis numéro (Symphony no. 8, 8. Sinfonie) */
export const SYMPHONY_NUM_AFTER = new RegExp(
  `(?:symphony|symphonie|sinfonia|sinfonie)\\s*(?:no\\.?|n°|number|nr|#)?\\s*(\\d+)`,
  'i'
)
export const SYMPHONY_NUM_FIRST = new RegExp(
  `(\\d+)\\s*\\.?\\s*(?:symphony|symphonie|sinfonia|sinfonie)`,
  'i'
)
